// extracted by mini-css-extract-plugin
export default {"popup":"GamesFiltersPopup__popup--3UD","opened":"GamesFiltersPopup__opened--9Gj","overlay":"GamesFiltersPopup__overlay--2c_"};